import { gql } from '@/utilities/gql';
import { useUser } from '../useUser';
import { makeGqlQuery } from '@/utilities/gqlQuery';

const QUERY = gql(`
  query UserProfile {
    me {
      communityProfile {
        displayName
        publicId
        role
        imageUrl
        slug
      }
    }
  }
`);

const useMeForUserProfile = makeGqlQuery(QUERY, {
  staleTime: Infinity,
  tags: ['community-profile'],
});

export const useUserProfile = () => {
  const { data: user, queryStatus } = useUser();

  const { data: userProfileResponse, isLoading } = useMeForUserProfile(
    {},
    {
      enabled: !!user?.loggedIn,
    }
  );

  return {
    isLoading: isLoading || queryStatus === 'pending',
    isLoggedIn: user?.loggedIn,
    user,
    communityProfile: userProfileResponse?.me?.communityProfile,
    userId: user.id,
    publicId: userProfileResponse?.me?.communityProfile?.publicId,
  };
};
